import React, { Component } from 'react'
import { FormattedMessage } from 'react-intl'

class CalendarEventStatusBadge extends Component {

    constructor(props, context) {
        super(props, context);
        this.state = {
            status: this.props.status || '',
            style: this.props.style || {},
        }
        this.className = this.props.className || ''
    }
    componentWillReceiveProps(nextProps, nextContext) {
        this.setState({
            status: nextProps.status || '',
            style: nextProps.style || {},
        })
    }

    renderStatus() {
        switch (this.state.status) {
            case 'confirmed':
                return <div className="badge badge-success text-with-icon">
                    <FormattedMessage
                        id="calendar_event.status.confirmed_label"
                        defaultMessage="Confirmed"
                    />
                </div>
            case 'cancelled':
                return <div className="badge badge-danger text-with-icon">
                    <FormattedMessage
                        id="calendar_event.status.cancelled_label"
                        defaultMessage="Cancelled"
                    />
                </div>
        }
        return <div />
    }

    render() {
        return <span className={this.className} style={this.state.style}>
            {this.renderStatus()}
        </span>
    }

}

export default CalendarEventStatusBadge





// WEBPACK FOOTER //
// ./src/scheduling-page/calendareventstatusbadge.component.jsx